module.exports = __webpack_public_path__ + "static/img/396_phase_function_Paper_PointsHejduk_Prediction.dc81a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/396_phase_function_Paper_PointsHejduk_Prediction.png
// module id = rnwu
// module chunks = 0